import { PHOTO_BASE as PUBLIC_URL } from '../utils/photoUrl';

// OneKey photos featured on About / Fundraisers pages — used by the home hero slideshow
export const PAGE_PHOTOS = [
  `${PUBLIC_URL}/pics/onekey.jpg`,
  `${PUBLIC_URL}/pics/onekey_team.jpg`,
  `${PUBLIC_URL}/pics/onekey_history.jpg`,
  `${PUBLIC_URL}/pics/onekey_cavell.jpg`,
  `${PUBLIC_URL}/pics/onekey_cellos.jpg`,
  `${PUBLIC_URL}/pics/onekey_perform_mic.jpg`,
  `${PUBLIC_URL}/pics/onekey_homework.jpg`,
];

export const allPhotos = [
  ...PAGE_PHOTOS,
  `${PUBLIC_URL}/slideshow/041A0050.JPG`,
  `${PUBLIC_URL}/slideshow/041A0051.JPG`,
  `${PUBLIC_URL}/slideshow/041A0053.JPG`,
  `${PUBLIC_URL}/slideshow/041A0054.JPG`,
  `${PUBLIC_URL}/slideshow/041A0056.JPG`,
  `${PUBLIC_URL}/slideshow/041A0057.JPG`,
  `${PUBLIC_URL}/slideshow/041A0059.JPG`,
  `${PUBLIC_URL}/slideshow/041A0060.JPG`,
  `${PUBLIC_URL}/slideshow/041A0062.JPG`,
  `${PUBLIC_URL}/slideshow/041A0071.JPG`,
  `${PUBLIC_URL}/slideshow/041A0072.JPG`,
  `${PUBLIC_URL}/slideshow/041A0077.JPG`,
  `${PUBLIC_URL}/slideshow/041A0081.JPG`,
  `${PUBLIC_URL}/slideshow/041A0087.JPG`,
  `${PUBLIC_URL}/slideshow/041A0089.JPG`,
  `${PUBLIC_URL}/slideshow/041A0097.JPG`,
  `${PUBLIC_URL}/slideshow/041A0100.JPG`,
  `${PUBLIC_URL}/slideshow/041A0102.JPG`,
  `${PUBLIC_URL}/slideshow/041A0105.JPG`,
  `${PUBLIC_URL}/slideshow/041A0108.JPG`,
  `${PUBLIC_URL}/slideshow/041A0110.JPG`,
  `${PUBLIC_URL}/slideshow/041A0113.JPG`,
  `${PUBLIC_URL}/slideshow/041A0117.JPG`,
  `${PUBLIC_URL}/slideshow/041A0123.JPG`,
  `${PUBLIC_URL}/slideshow/041A0126.JPG`,
  `${PUBLIC_URL}/slideshow/041A0127.JPG`,
  `${PUBLIC_URL}/slideshow/041A0155.JPG`,
  `${PUBLIC_URL}/slideshow/041A0156.JPG`,
  `${PUBLIC_URL}/slideshow/041A0159.JPG`,
  `${PUBLIC_URL}/slideshow/041A0184.JPG`,
  `${PUBLIC_URL}/slideshow/041A0191.JPG`,
  `${PUBLIC_URL}/slideshow/041A0194.JPG`,
  `${PUBLIC_URL}/slideshow/041A0205.JPG`,
  `${PUBLIC_URL}/slideshow/041A0209.JPG`,
  `${PUBLIC_URL}/slideshow/041A0214.JPG`,
  `${PUBLIC_URL}/slideshow/041A0272.JPG`,
  `${PUBLIC_URL}/slideshow/041A0291.JPG`,
  `${PUBLIC_URL}/slideshow/041A0301.JPG`,
  `${PUBLIC_URL}/slideshow/041A0316.JPG`,
  `${PUBLIC_URL}/slideshow/041A0334.JPG`,
  `${PUBLIC_URL}/slideshow/041A0344.JPG`,
  `${PUBLIC_URL}/slideshow/041A0409.JPG`,
  `${PUBLIC_URL}/slideshow/041A0412.JPG`,
  `${PUBLIC_URL}/slideshow/041A0433.JPG`,
  `${PUBLIC_URL}/slideshow/041A0486.JPG`,
  `${PUBLIC_URL}/slideshow/041A0491.JPG`,
  `${PUBLIC_URL}/slideshow/041A0501.JPG`,
  `${PUBLIC_URL}/slideshow/041A0512.JPG`,
  `${PUBLIC_URL}/slideshow/041A1349.JPG`,
  `${PUBLIC_URL}/slideshow/041A1350.JPG`,
  `${PUBLIC_URL}/slideshow/041A1352.JPG`,
  `${PUBLIC_URL}/slideshow/041A1353.JPG`,
  `${PUBLIC_URL}/slideshow/041A1355.JPG`,
  `${PUBLIC_URL}/slideshow/041A1357.JPG`,
  `${PUBLIC_URL}/slideshow/041A1374.JPG`,
  `${PUBLIC_URL}/slideshow/041A1375.JPG`,
  `${PUBLIC_URL}/slideshow/041A1381.JPG`,
  `${PUBLIC_URL}/slideshow/041A1382.JPG`,
  `${PUBLIC_URL}/slideshow/041A1386.JPG`,
  `${PUBLIC_URL}/slideshow/041A1392.JPG`,
  `${PUBLIC_URL}/slideshow/041A1407.JPG`,
  `${PUBLIC_URL}/slideshow/041A1412.JPG`,
  `${PUBLIC_URL}/slideshow/041A1422.JPG`,
  `${PUBLIC_URL}/slideshow/041A1430.JPG`,
  `${PUBLIC_URL}/slideshow/041A1454.JPG`,
  `${PUBLIC_URL}/slideshow/041A1470.JPG`,
  `${PUBLIC_URL}/slideshow/041A1485.JPG`,
  `${PUBLIC_URL}/slideshow/041A1486.JPG`,
  `${PUBLIC_URL}/slideshow/041A1489.JPG`,
  `${PUBLIC_URL}/slideshow/041A1490.JPG`,
  `${PUBLIC_URL}/slideshow/041A1492.JPG`,
  `${PUBLIC_URL}/slideshow/041A1502.JPG`,
  `${PUBLIC_URL}/slideshow/041A1513.JPG`,
  `${PUBLIC_URL}/slideshow/041A1571.JPG`,
  `${PUBLIC_URL}/slideshow/041A1575.JPG`,
  `${PUBLIC_URL}/slideshow/041A1580.JPG`,
  `${PUBLIC_URL}/slideshow/041A1588.JPG`,
  `${PUBLIC_URL}/slideshow/041A1601.JPG`,
  `${PUBLIC_URL}/slideshow/041A1614.JPG`,
  `${PUBLIC_URL}/slideshow/041A1636.JPG`,
  `${PUBLIC_URL}/slideshow/041A5710.JPG`,
  `${PUBLIC_URL}/slideshow/041A5715.JPG`,
  `${PUBLIC_URL}/slideshow/041A5716.JPG`,
  `${PUBLIC_URL}/slideshow/041A5735.JPG`,
  `${PUBLIC_URL}/slideshow/041A5742.JPG`,
  `${PUBLIC_URL}/slideshow/041A5760.JPG`,
  `${PUBLIC_URL}/slideshow/041A5769.JPG`,
  `${PUBLIC_URL}/slideshow/041A5771.JPG`,
  `${PUBLIC_URL}/slideshow/041A5772.JPG`,
  `${PUBLIC_URL}/slideshow/041A5780.JPG`,
  `${PUBLIC_URL}/slideshow/041A5793.JPG`,
  `${PUBLIC_URL}/slideshow/041A5801.JPG`,
  `${PUBLIC_URL}/slideshow/041A5809.JPG`,
  `${PUBLIC_URL}/slideshow/041A5816.JPG`,
  `${PUBLIC_URL}/slideshow/041A5836.JPG`,
  `${PUBLIC_URL}/slideshow/041A5863.JPG`,
  `${PUBLIC_URL}/slideshow/041A5869.JPG`,
  `${PUBLIC_URL}/slideshow/041A5878.JPG`,
  `${PUBLIC_URL}/slideshow/041A5891.JPG`,
  `${PUBLIC_URL}/slideshow/041A5903.JPG`,
  `${PUBLIC_URL}/slideshow/041A5912.JPG`,
  `${PUBLIC_URL}/slideshow/041A5958.JPG`,
  `${PUBLIC_URL}/slideshow/041A5961.JPG`,
  `${PUBLIC_URL}/slideshow/041A5972.JPG`,
  `${PUBLIC_URL}/slideshow/041A6016.JPG`,
  `${PUBLIC_URL}/slideshow/041A6058.JPG`,
  `${PUBLIC_URL}/slideshow/041A6121.JPG`,
  `${PUBLIC_URL}/slideshow/041A6130.JPG`,
  `${PUBLIC_URL}/slideshow/041A6137.JPG`,
  `${PUBLIC_URL}/slideshow/041A6154.JPG`,
  `${PUBLIC_URL}/slideshow/041A6159.JPG`,
  `${PUBLIC_URL}/slideshow/041A6172.JPG`,
  `${PUBLIC_URL}/slideshow/041A6203.JPG`,
  `${PUBLIC_URL}/slideshow/041A6210.JPG`,
  `${PUBLIC_URL}/slideshow/041A6211.JPG`,
  `${PUBLIC_URL}/slideshow/041A7162.JPG`,
  `${PUBLIC_URL}/slideshow/041A7165.JPG`,
  `${PUBLIC_URL}/slideshow/041A7168.JPG`,
  `${PUBLIC_URL}/slideshow/041A7169.JPG`,
  `${PUBLIC_URL}/slideshow/041A7173.JPG`,
  `${PUBLIC_URL}/slideshow/041A7184.JPG`,
  `${PUBLIC_URL}/slideshow/041A7190.JPG`,
  `${PUBLIC_URL}/slideshow/041A7194.JPG`,
  `${PUBLIC_URL}/slideshow/041A7195.JPG`,
  `${PUBLIC_URL}/slideshow/041A7210.JPG`,
  `${PUBLIC_URL}/slideshow/041A7212.JPG`,
  `${PUBLIC_URL}/slideshow/041A7215.JPG`,
  `${PUBLIC_URL}/slideshow/041A7219.JPG`,
  `${PUBLIC_URL}/slideshow/041A7229.JPG`,
  `${PUBLIC_URL}/slideshow/041A7231.JPG`,
  `${PUBLIC_URL}/slideshow/041A7235.JPG`,
  `${PUBLIC_URL}/slideshow/041A7239.JPG`,
  `${PUBLIC_URL}/slideshow/041A7241.JPG`,
  `${PUBLIC_URL}/slideshow/041A7247.JPG`,
  `${PUBLIC_URL}/slideshow/041A7252.JPG`,
  `${PUBLIC_URL}/slideshow/041A7261.JPG`,
  `${PUBLIC_URL}/slideshow/041A7267.JPG`,
  `${PUBLIC_URL}/slideshow/041A7299.JPG`,
  `${PUBLIC_URL}/slideshow/041A7334.JPG`,
  `${PUBLIC_URL}/slideshow/041A73341.JPG`,
  `${PUBLIC_URL}/slideshow/041A7337.JPG`,
  `${PUBLIC_URL}/slideshow/041A7358.JPG`,
  `${PUBLIC_URL}/slideshow/041A7360.JPG`,
  `${PUBLIC_URL}/slideshow/041A7361.JPG`,
  `${PUBLIC_URL}/slideshow/041A7376.JPG`,
  `${PUBLIC_URL}/slideshow/041A7377.JPG`,
  `${PUBLIC_URL}/slideshow/041A7380.JPG`,
  `${PUBLIC_URL}/slideshow/041A7387.JPG`,
  `${PUBLIC_URL}/slideshow/041A7397.JPG`,
  `${PUBLIC_URL}/slideshow/041A7398.JPG`,
  `${PUBLIC_URL}/slideshow/041A7402.JPG`,
  `${PUBLIC_URL}/slideshow/041A7409.JPG`,
  `${PUBLIC_URL}/slideshow/041A7412.JPG`,
  `${PUBLIC_URL}/slideshow/041A7416.JPG`,
  `${PUBLIC_URL}/slideshow/041A7434.JPG`,
  `${PUBLIC_URL}/slideshow/041A7435.JPG`,
  `${PUBLIC_URL}/slideshow/041A7437.JPG`,
  `${PUBLIC_URL}/slideshow/041A7473.JPG`,
  `${PUBLIC_URL}/slideshow/041A7568.JPG`,
  `${PUBLIC_URL}/slideshow/041A7570.JPG`,
  `${PUBLIC_URL}/slideshow/041A7576.JPG`,
  `${PUBLIC_URL}/slideshow/041A7598.JPG`,
  `${PUBLIC_URL}/slideshow/041A7601.JPG`,
  `${PUBLIC_URL}/slideshow/041A7602.JPG`,
  `${PUBLIC_URL}/slideshow/041A7684.JPG`,
  `${PUBLIC_URL}/slideshow/041A7690.JPG`,
  `${PUBLIC_URL}/slideshow/041A7695.JPG`,
  `${PUBLIC_URL}/slideshow/041A7698.JPG`,
  `${PUBLIC_URL}/slideshow/041A7701.JPG`,
  `${PUBLIC_URL}/slideshow/041A7709.JPG`,
  `${PUBLIC_URL}/slideshow/041A7711.JPG`,
  `${PUBLIC_URL}/slideshow/041A7718.JPG`,
  `${PUBLIC_URL}/slideshow/041A7720.JPG`,
  `${PUBLIC_URL}/slideshow/041A7722.JPG`,
  `${PUBLIC_URL}/slideshow/041A7732.JPG`,
  `${PUBLIC_URL}/slideshow/041A7738.JPG`,
  `${PUBLIC_URL}/slideshow/041A7745.JPG`,
  `${PUBLIC_URL}/slideshow/041A7757.JPG`,
  `${PUBLIC_URL}/slideshow/041A7789.JPG`,
  `${PUBLIC_URL}/slideshow/041A7793.JPG`,
  `${PUBLIC_URL}/slideshow/041A7819.JPG`,
  `${PUBLIC_URL}/slideshow/041A7822.JPG`,
  `${PUBLIC_URL}/slideshow/041A7880.JPG`,
  `${PUBLIC_URL}/slideshow/041A7882.JPG`,
  `${PUBLIC_URL}/slideshow/041A7888.JPG`,
  `${PUBLIC_URL}/slideshow/041A7889.JPG`,
  `${PUBLIC_URL}/slideshow/041A7891.JPG`,
  `${PUBLIC_URL}/slideshow/041A7892.JPG`,
  `${PUBLIC_URL}/slideshow/041A7898.JPG`,
  `${PUBLIC_URL}/slideshow/041A7902.JPG`,
  `${PUBLIC_URL}/slideshow/041A7908.JPG`,
  `${PUBLIC_URL}/slideshow/041A7911.JPG`,
  `${PUBLIC_URL}/slideshow/041A7915.JPG`,
  `${PUBLIC_URL}/slideshow/041A7919.JPG`,
  `${PUBLIC_URL}/slideshow/041A7922.JPG`,
  `${PUBLIC_URL}/slideshow/041A7923.JPG`,
  `${PUBLIC_URL}/slideshow/041A7928.JPG`,
  `${PUBLIC_URL}/slideshow/041A7932.JPG`,
  `${PUBLIC_URL}/slideshow/041A7937.JPG`,
  `${PUBLIC_URL}/slideshow/041A7950.JPG`,
  `${PUBLIC_URL}/slideshow/041A7956.JPG`,
  `${PUBLIC_URL}/slideshow/041A7958.JPG`,
  `${PUBLIC_URL}/slideshow/041A7979.JPG`,
  `${PUBLIC_URL}/slideshow/041A7982.JPG`,
  `${PUBLIC_URL}/slideshow/041A8008.JPG`,
  `${PUBLIC_URL}/slideshow/041A8012.JPG`,
  `${PUBLIC_URL}/slideshow/041A8035.JPG`,
  `${PUBLIC_URL}/slideshow/041A8043.JPG`,
  `${PUBLIC_URL}/slideshow/041A8108.JPG`,
  `${PUBLIC_URL}/slideshow/041A8113.JPG`,
  `${PUBLIC_URL}/slideshow/041A8122.JPG`,
  `${PUBLIC_URL}/slideshow/041A8124.JPG`,
  `${PUBLIC_URL}/slideshow/041A8130.JPG`,
  `${PUBLIC_URL}/slideshow/041A8139.JPG`,
  `${PUBLIC_URL}/slideshow/041A8172.JPG`,
  `${PUBLIC_URL}/slideshow/041A8185.JPG`,
  `${PUBLIC_URL}/slideshow/041A8242.JPG`,
  `${PUBLIC_URL}/slideshow/041A8258.JPG`
];

export const getRandomPhotos = (count: number) => {
  const arr = [...allPhotos];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr.slice(0, count);
};
